const AVATAR_COLOR_COUNT = 8

// djb2-style hash — deterministic, so the same seed always yields the same bucket
const hashSeed = (seed: string): number => {
  let hash = 5381
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 33) ^ seed.charCodeAt(i)
  }
  return Math.abs(hash) % AVATAR_COLOR_COUNT
}

export const getAvatarInitialsColorClass = (seed: string): string =>
  `profile-dot--initials-${hashSeed(seed)}`
